import { Component } from '@angular/core';

@Component({
  selector: 'app-cerez-bilgilendirme-metni',
  templateUrl: './cerez-bilgilendirme-metni.component.html'
})
export class CerezBilgilendirmeMetniComponent {
  /** Metinde esasa ilişkin her değişiklikte aynı commit içinde güncellenmelidir. */
  readonly lastUpdated = { iso: '2026-07-27', label: '27 Temmuz 2026' };
}
